import { render, staticRenderFns } from "./grid-parama.vue?vue&type=template&id=65507a64&scoped=true&"
import script from "./grid-parama.vue?vue&type=script&lang=js&"
export * from "./grid-parama.vue?vue&type=script&lang=js&"
import style0 from "./grid-parama.vue?vue&type=style&index=0&id=65507a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65507a64",
  null
  
)

export default component.exports